import React, { Component } from 'react';
import { Label, Radio, Header } from 'semantic-ui-react';

class RadioHeader extends Component {
  click = () => {
    if (this.props.onChange) {
      this.props.onChange(true);
    } else if (this.props.onClick) {
      this.props.onClick();
    }
  };

  render() {
    const {
      as, label, name, value, checked, onChange, header, content, style = {}, onClick = () => {},
    } = this.props;
    return (
      <div style={{
        marginBottom: 20, display: 'flex', flex: 'auto', ...style,
      }}>
        <div style={{ textAlign: 'center', paddingTop: 10 }}>
          <Radio label={null} name={name} value={value} checked={checked} onClick={onClick} onChange={(e, c) => onChange && onChange(c.checked)} />
        </div>
        <div style={{ paddingLeft: 15 }} onClick={this.click}>
          <Header as={as} style={{ marginBottom: 5, cursor: 'pointer' }}>{header} {label && <Label>{label}</Label>}</Header>
          <div>{content}</div>
        </div>

        <div style={{ clear: 'both' }} />
      </div>
    );
  }
}

export default RadioHeader;
